import { render, staticRenderFns } from "./returnRecord.vue?vue&type=template&id=46da190d&scoped=true&"
import script from "./returnRecord.vue?vue&type=script&lang=js&"
export * from "./returnRecord.vue?vue&type=script&lang=js&"
import style0 from "./returnRecord.vue?vue&type=style&index=0&id=46da190d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46da190d",
  null
  
)

export default component.exports